import InputGroupsContainer from "../../../../../Components/Forms&Table/Forms/FormControls/InputGroups/InputGroupContainer";

const InputGroup = () => {
  return <InputGroupsContainer />;
};

export default InputGroup;
